/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 198);
/******/ })
/************************************************************************/
/******/ ({

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(199);
module.exports = __webpack_require__(200);


/***/ }),

/***/ 199:
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window$Liftoff = window.Liftoff,
    Component = _window$Liftoff.Component,
    Utils = _window$Liftoff.Utils,
    DOMUtils = _window$Liftoff.DOMUtils;


Component.register("image", function (_Component) {
  _inherits(Image, _Component);

  function Image(config) {
    _classCallCheck(this, Image);

    var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, config));

    Utils.assignWithDefaults(_this, {
      image: null,
      size: null,
      hpos: null,
      vpos: null,
      width: "100%",
      height: "100%",
      style: null,
      animation: null,
      popDurationMS: 500,
      popIterations: 1,
      animateInMethod: null,
      animateInDurationMS: 500,
      animateInDelayMS: 0
    }, _this.config);
    _this.image = _this.image || null;

    // NOTE(brian): Temporary correction for switchover from background-size to
    // object-fit.
    if (_this.size === "100% 100%") {
      _this.size = "fill";
    }
    return _this;
  }

  _createClass(Image, [{
    key: "load",
    value: function load() {
      return this.isEmpty() ? Promise.resolve() : Utils.loadImage(this.image);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return !this.image;
    }
  }, {
    key: "layout",
    value: function layout(parentNode) {
      _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), "layout", this).call(this, parentNode);

      this.el = document.createElement("img");
      this.el.classList.add("image-component");
      this.render();
      this.parentNode.appendChild(this.el);

      if (this.animateInMethod) {
        this.el.classList.add("animation-" + this.animateInMethod);
        DOMUtils.forceReflow(this.el);
        this.el.style.transitionDuration = this.animateInDurationMS + "ms";
        this.el.style.transitionDelay = this.animateInDelayMS + "ms";
      }

      this.addEventListeners();
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;

      this.on("set image", function (_ref) {
        var image = _ref.image;

        if (image === "") return;

        _this2.image = image;
        _this2.render();
      });

      this.on("animateIn", function () {
        if (_this2.animateInMethod) {
          _this2.el.classList.add("animate-in");
          if (_this2.animation) {
            DOMUtils.addOneTimeListener(_this2.el, "transitionend", function () {
              return _this2._startRepeatingAnimation();
            });
          }
        }
      });
    }
  }, {
    key: "resize",
    value: function resize() {
      return true;
    }
  }, {
    key: "start",
    value: function start() {
      if (!this.animateInMethod && this.animation) {
        this._startRepeatingAnimation();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.animation) {
        this.el.classList.remove(this.animation);
      }
    }
  }, {
    key: "restart",
    value: function restart() {
      this.stop();
      DOMUtils.forceReflow(this.el);
      this.start();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.image) return;

      Object.assign(this.el.style, {
        width: this.width,
        height: this.height,
        objectPosition: this.hpos + " " + this.vpos,
        objectFit: this.size
      }, this.style);
      this.el.src = this.image;
    }
  }, {
    key: "_startRepeatingAnimation",
    value: function _startRepeatingAnimation() {
      if (!this.animation) return;

      Object.assign(this.el.style, { animationDelay: "0" });
      if (["pop", "blur-and-spin", "colorize"].includes(this.animation)) {
        Object.assign(this.el.style, {
          animationDuration: this.popDurationMS + "ms",
          animationIterationCount: "" + (this.popIterations === Infinity ? "infinite" : this.popIterations)
        });
      }

      this.el.classList.add(this.animation);
    }
  }]);

  return Image;
}(Component));

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// image.js